<!--<pre>options: {{options|json}}</pre>-->
<div class="d-flex flex-wrap align-items-start">
  <label class="col-12">
    <span [inlineSVG]="icon" class="svg-icon svg-icon-2 me-2"></span>
    <span class="fw-bolder">{{ label }} {{ isOptional ? '(Opsional)' : '' }}</span>
  </label>

  <div *ngIf="areaValue.value.length > 1" class="col-12 d-flex align-items-center mt-4">
    <mat-checkbox
      (change)="handleChecked($event.checked)"
      [checked]="false"
      [color]="'primary'"
    ></mat-checkbox>
    <span>{{ 'Digantikan beberapa ' + roleValue }}</span>
  </div>

  <div *ngIf="checkedRole.value; else notChecked" [formGroup]="DataForm" class="col-12">
    <div [formArrayName]="'areas'">
      <div
        *ngFor="let item of AreaFormArray.controls; let i = index"
        [formGroupName]="i"
        class="col-12 mt-4"
      >
        <div class="my-3 fw-bold">
          {{ EnumRoleLabel[enumRole] }} Pengganti ({{ AreaFromArray(i)?.value.label }})
        </div>

        <div class="position-relative">
          <input
            #trigger="matAutocompleteTrigger"
            [formControlName]="'employee'"
            [matAutocomplete]="auto"
            (keyup)="subscribeEmployeeValueChanges(i)"
            [placeholder]="placeholder"
            [readonly]="disabled"
            class="form-control form-control-solid"
            matInput
            ngDefaultControl
            type="text"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onOptionSelected($event)"
            [displayWith]="displayFn"
          >
            <mat-option *ngFor="let option of optionsSubject | async" [value]="option">
              <div class="my-3">
                <div class="fs-14">{{ option.label }}</div>
                <div class="text-gray-500 fs-12">{{ option.description }}</div>
              </div>
            </mat-option>
          </mat-autocomplete>
          <span
            *ngIf="loadingSubject | async"
            class="spinner-border spinner-border-sm align-middle m-auto"
            style="position: absolute; top: 0; bottom: 0; right: 20px"
          ></span>
          <span
            (click)="trigger.openPanel(); $event.stopPropagation()"
            [inlineSVG]="STRING_CONSTANTS.ICON.IC_ARROW_MINI_DOWN"
            class="svg-icon svg-icon-1 cursor-pointer"
            ngbAutoFocus
          ></span>
        </div>

        <!--  <pre>searchnotfound:  {{ searchNotFound() }}</pre>-->

        <div *ngIf="!loadingSubject.value && searchNotFound()" class="px-2 mt-2">
          <span class="fs-8">Tidak ada data</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #notChecked>
    <div class="col-12 mt-3">
      <div class="position-relative" [formGroup]="DataForm">
        <input
          #trigger="matAutocompleteTrigger"
          [formControl]="EmployeeForm"
          [matAutocomplete]="auto"
          [placeholder]="placeholder"
          [readonly]="disabled"
          class="form-control form-control-solid"
          matInput
          type="text"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onOptionSelected($event)"
          [displayWith]="displayFn"
        >
          <mat-option *ngFor="let option of optionsSubject | async" [value]="option">
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>
        <span
          *ngIf="loadingSubject | async"
          class="spinner-border spinner-border-sm align-middle m-auto"
          style="position: absolute; top: 0; bottom: 0; right: 20px"
        ></span>
        <span
          (click)="trigger.openPanel(); $event.stopPropagation()"
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_ARROW_MINI_DOWN"
          class="svg-icon svg-icon-1 cursor-pointer"
          ngbAutoFocus
        ></span>
      </div>

      <!--  <pre>searchnotfound:  {{ searchNotFound() }}</pre>-->

      <div *ngIf="!loadingSubject.value && searchNotFound()" class="px-2 mt-2">
        <span class="fs-8">Tidak ada data</span>
      </div>
    </div>
  </ng-template>
</div>
